import _toConsumableArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import PropTypes from 'prop-types';
import React__default from 'react';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { ThumbnailsHeroBackgroundContainer } from './thumbnails-hero-background-container.component.js';
import { ThumbnailsHeroContentContainer } from './thumbnails-hero-content-container.component.js';
import { ThumbnailsHeroImagesSlidesContainer } from './thumbnails-hero-images-slides-container.component.js';
import { ThumbnailsHeroThumbnailsSlidesContainer } from './thumbnails-hero-thumbnails-slides-container.component.js';
import { CarouselSlide } from '../carousel/carousel-slide.component.js';
import { Carousel } from '../carousel/carousel.component.js';
import { SCREEN_CLASS_MIN_WIDTHS } from '../../../core/constants/tokens-screen.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';
var propTypes = {
  /**
  * The visual style of the thumbnails hero.
  * Available options: 'standard', 'under'
  */
  skin: PropTypes.oneOf(['standard', 'under']),

  /**
  * The width of the content area.
  * Available options: 'standard', 'wide'
  */
  contentWidth: PropTypes.oneOf(['standard', 'wide']),

  /**
  * The index of the slide to select
  */
  currentSlide: PropTypes.number,

  /**
  * A callback fired when the ThumbnailsHero changes the selected slide.
  * It is passed the index of the currently selected slide and the index of the slide it will change to
  */
  onSlideChange: PropTypes.func,

  /**
  * Provide accessible text for slide controllers
  */
  accessibleTextForDots: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
};
var propKeysToRemove = Object.keys(propTypes);
var ThumbnailsHero = renderWithRef('ThumbnailsHero', propTypes, function (props, ref) {
  useComponentStylesLoaded('ThumbnailsHero', SWAN_STYLE_KEY_MAP.thumbnailsHero);
  var _props$skin = props.skin,
      skin = _props$skin === void 0 ? 'standard' : _props$skin,
      _props$contentWidth = props.contentWidth,
      contentWidth = _props$contentWidth === void 0 ? 'standard' : _props$contentWidth,
      _props$currentSlide = props.currentSlide,
      currentSlide = _props$currentSlide === void 0 ? 0 : _props$currentSlide,
      accessibleTextForDots = props.accessibleTextForDots,
      onSlideChange = props.onSlideChange,
      children = props.children;
  var thumbnailsArray = [];
  var imagesArray = [];
  var backgroundContainer = null;
  var contentContainer = null;
  React__default.Children.forEach(children, function (child) {
    if (! /*#__PURE__*/React__default.isValidElement(child)) return;

    switch (child.type) {
      case ThumbnailsHeroThumbnailsSlidesContainer:
        thumbnailsArray.push.apply(thumbnailsArray, _toConsumableArray(React__default.Children.map(child.props.children, function (grandChild, index) {
          return (// eslint-disable-next-line react/no-array-index-key
            grandChild.type === CarouselSlide ? /*#__PURE__*/React__default.cloneElement(grandChild, {
              key: index,
              component: grandChild.props.component || 'span'
            }) : null
          );
        })));
        break;

      case ThumbnailsHeroImagesSlidesContainer:
        imagesArray.push.apply(imagesArray, _toConsumableArray(React__default.Children.map(child.props.children, function (grandChild, index) {
          return grandChild.type === CarouselSlide ? /*#__PURE__*/React__default.cloneElement(grandChild, {
            key: index
          }) : null;
        })));
        break;

      case ThumbnailsHeroBackgroundContainer:
        backgroundContainer = child;
        break;

      case ThumbnailsHeroContentContainer:
        contentContainer = child;
        break;
    }
  });
  var classNames = new Set(['swan-thumbnails-hero', "swan-thumbnails-hero-skin-".concat(skin)]);
  if (contentWidth !== 'standard') classNames.add("swan-thumbnails-hero-content-".concat(contentWidth));
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(RenderComp, {
    root: "div",
    forwardedRef: ref,
    propKeysToRemove: propKeysToRemove,
    classNames: classNames,
    props: props
  }, backgroundContainer, /*#__PURE__*/React__default.createElement("div", {
    className: "swan-thumbnails-hero-images-carousel-container"
  }, /*#__PURE__*/React__default.createElement(Carousel, {
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: false,
    accessibleTextForNext: "",
    accessibleTextForPrevious: "",
    accessibleTextForDots: accessibleTextForDots,
    customPaging: function customPaging(index) {
      return /*#__PURE__*/React__default.createElement("button", {
        "aria-label": accessibleTextForDots[index],
        key: index
      }, thumbnailsArray[index]);
    },
    progressIndicator: skin === 'under' ? 'dots' : 'dots-inset',
    progressIndicatorAlignment: skin === 'under' ? 'left' : 'center',
    currentSlide: currentSlide || 0,
    beforeChange: onSlideChange || undefined,
    fade: true,
    responsive: [{
      breakpoint: SCREEN_CLASS_MIN_WIDTHS.md,
      settings: {
        fade: false
      }
    }]
  }, imagesArray)), contentContainer));
});
ThumbnailsHero.defaultProps = {
  skin: 'standard',
  contentWidth: 'standard'
};
export { ThumbnailsHero };